/*=========================================================================================
  File Name: moduleSms.js
  Description: Sms Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleSmsState.js'
import mutations from './moduleSmsMutations.js'
import actions from './moduleSmsActions.js'
import getters from './moduleSmsGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
